// Country-based currency and locale configuration
import { getCurrency, getLocale } from './config/countryConfig';

// Safely check for window.ENV (runtime via Docker) then REACT_APP_ENV, fallback to 'production'
const currentEnv = window?.ENV?.REACT_APP_ENV || process.env.REACT_APP_ENV || 'production';

export const API_URL =
  window?.ENV?.API_URL || process.env.REACT_APP_API_URL ||
  (currentEnv === 'development' ? 'https://api.dev.saydalid.com' : 'https://backend.saydalid.com');

/**
 * Dynamic currency configuration based on user's country
 * Usage: CURRENCY.code (e.g., "TND" or "DZD")
 *        CURRENCY.symbol (e.g., "dt" or "DA")
 */
export const CURRENCY = new Proxy(
  {},
  {
    get: (target, prop) => {
      const currency = getCurrency();
      return currency[prop] || currency.code;
    },
  }
);

/**
 * Get locale string for current country
 * Usage: getLOCALE() returns "fr-FR" or "fr-DZ"
 */
export const getLOCALE = () => getLocale();